import axios from "axios";
import global_ from "@/global.config";
import request from "@/utils/request";
import qs from 'querystring'

function actRequestApi(path, method = 'get', data = {}, reqHeaders = {}){
    const headers = {"Content-Type": "application/json;charset=UTF-8", ...reqHeaders}
    const url = 'https://actapi.ttrsznkj.com' + path
    return axios({
        method,
        url,
        params: method === 'get' ? data : {},
        data,
        headers
    })
}
/**
 * 获取车辆列表
 * @param {object} params 接口参数
 */
export const getUsedCarList = params => request.post(`${window.location.protocol}//${global_.API_DOMAIN}/qc-webapp/m/car/cbi/list?${qs.stringify(params)}`)
/**
 * 汽车详情信息
 * @param {string} id 汽车psn码
 */
export const getCarItemInfo = id => request.post(`${window.location.protocol}//${global_.API_DOMAIN}/qc-webapp/m/car/cbi/get/${id}`)
/**
 * 获取一个检测报告详情
 * @param {string} id 检测报告uuid 
 */
export const getCarDetectInfo = id => request.post(`${window.location.protocol}//${global_.API_DOMAIN}/qc-webapp/m/car/ccr/get/${id}`)
/**
 * 创建一个收藏
 * @param {object} params 收藏体 
 */
export const createFavorite = params => request.post2(`${window.location.protocol}//${global_.API_DOMAIN}/qc-webapp/m/car/cmf/create`, params)
/**
 * 删除一个收藏
 * @param {object} params 收藏参数体
 */
export const removeFavorite = params => request.post2(`${window.location.protocol}//${global_.API_DOMAIN}/qc-webapp/m/car/cmf/delete`, params)
/**
 * 获取一个收藏
 * @param {object} params 收藏参数体
 */
export const getFavorite = params => request.post2(`${window.location.protocol}//${global_.API_DOMAIN}/qc-webapp/m/car/cmf/get`, params)
/**
 * 收藏列表
 * @param {object} params 查询参数体
 */
export const getFavoriteList = params => request.post(`${window.location.protocol}//${global_.API_DOMAIN}/qc-webapp/m/car/cmf/list?${qs.stringify(params)}`)
/**
 * 创建一个线索
 * @param {object} params 线索参数体
 */
export const createClue = params => {
    let pid;
    let type;
    const {atype} = params;
    if(atype == 4 || atype == 5){
        type = 1;
    }else{
        type = 2;
    }
    getProjects({appid:params.appid}).then(resp => {
        if(resp.code === 0){
          const {data} = resp;
          data.forEach((item)=>{
            if(type == item.type){
                pid = item.projectid;
            }
          })
          request.post2(`${window.location.protocol}//${global_.API_DOMAIN}/qc-webapp/m/car/cc/create`, {
              ...params,
              pid
          })
        }
    })
}
/**
 * 获取线索列表
 * @param {object} params 查询线索参数体
 */
export const getClueList = params => request.post(`${window.location.protocol}//${global_.API_DOMAIN}/qc-webapp/m/car/cc/list?${qs.stringify(params)}`)
/**
 * 获取一个意向金
 * @param {*} params 查询参数体
 */
export const getCem = params => request.post(`${window.location.protocol}//${global_.API_DOMAIN}/qc-webapp/p/car/cem/get`, params)
/**
 * 发送手机验证码
 * @param {string} mobile 手机号码
 */
export const smsSender = (mobile, reqHeader) => actRequestApi(`/yq-oop/oop/common/smsCode?mobile=${mobile}`, 'post', {}, reqHeader)// request.post(`${window.location.protocol}//${global_.API_DOMAIN}/yq-oop/oop/common/smsCode?mobile=${mobile}`)
/**
 * 获取券信息
 * @param {object} reqHeader 验证头
 */
export const getTicketList = reqHeader => actRequestApi(`/yq-oop/oop/coupon/list`, 'get', {}, reqHeader)
/**
 * 取优惠券
 * @param {string} params 领券参数体
 * @param {object} reqHeader 验证头
 */
export const pickTicket = (params, reqHeader) => actRequestApi(`/yq-oop/oop/coupon/receive/${params.couponId}`, 'post', params, reqHeader)
/**
 * 获取已领取的券
 * @param {string} openid 用户openid
 * @param {object} reqHeader 验证头
 */
export const getMyTicketList = (openid, reqHeader) => actRequestApi(`/yq-oop/oop/coupon/coupon/my/${openid}`, 'get', {}, reqHeader)
/**
 * 获取首页对应的关联项目信息
 * @param {string} channelId 频道ID，即pageid_2
 * @param {object} reqHeader 验证头
 */
export const getProjectByChlid = (channelId, reqHeader) => actRequestApi(`/yq-oop/project/${channelId}`, 'get', {}, reqHeader)
/**
 * 创建一个意向金支付
 * @param {object} params 支付参数体
 */
export const createPay = params => request.post2(`${window.location.protocol}//${global_.API_DOMAIN}/qc-webapp/m/car/cem/create`, params)
/**
 * 获取一个意向金支付信息
 * @param {object} params 支付参数体
 */
export const getPayInfo = params => request.post2(`${window.location.protocol}//${global_.API_DOMAIN}/qc-webapp/m/car/cem/get`, params)
/**
 * 我买/卖的车列表
 * @param {object} params 查询参数体
 */
export const getMyCars = params => request.post2(`${window.location.protocol}//${global_.API_DOMAIN}/qc-webapp/m/car/my/tradeList`, params)
/**
 * 获取当前公众号所有项目
 * @param {object} params 参数体
 */
export const getProjects = params => request.post2(`${window.location.protocol}//${global_.API_DOMAIN}/qc-webapp/m/car/wx/projectList`, params)
/**
 * 核销礼品券
 * @param {object} params 参数体 
 */
export const verifica = params => request.post2(`${window.location.protocol}//${global_.API_DOMAIN}/qc-webapp/o/car/citroen/verifica`, params)